import { tanstackQueryCraft } from "./core";
import { ModuleConfig } from "./types";

/**
 * Register a module configuration under the given `name` in the global
 * `tanstackQueryCraft` registry and return the module unchanged.
 *
 * This is a convenience wrapper around the registry's `register` method
 * that preserves typing for the module being defined.
 *
 * @param name - The unique module name to register.
 * @param module - The module configuration object (queries/mutations).
 * @returns The same `module` object that was registered.
 */
export function defineModule<
  TModuleName extends string,
  TModule extends ModuleConfig
>(name: TModuleName, module: TModule): TModule {
  tanstackQueryCraft.register(name, module);

  return module as TModule;
}
